function onAdditionalFeedbackSubmit({articleId, updateRatingRequest, namespace}) {
  const textarea = document.getElementById(`${namespace}feedback_user_message`);
  const comment = textarea.value

  const radioButtonsForm = document.getElementById(`${namespace}radio_buttons_form`);
  const radioButtons = radioButtonsForm.querySelectorAll('input[type="radio"]');

  let dislikeReason = -1;
  radioButtons.forEach(radioButton => {
    if (radioButton.checked) {
      dislikeReason = radioButton.value;
    }
  });

  updateRatingRequest({dislikeReason, comment});
}

export default function ({updateRatingRequest, namespace}) {
  const submitButtonDiv = document.createElement('div')
  submitButtonDiv.classList.add('feedback_submit_button')

  const submitButton = document.createElement('button')
  submitButton.classList.add('gov-button', 'gov-button--primary')
  submitButton.innerText = Liferay.Language.get('articlefeedback.sendFeedback')
  submitButton.onclick = function () {
    onAdditionalFeedbackSubmit({rating: 1, updateRatingRequest, namespace});
  }

  submitButtonDiv.append(submitButton)
  return submitButtonDiv
}